import { callAPI } from '../../../../services/api.service';
import toast from 'react-hot-toast';
import { BookImageGenerationMode } from '../../../../interfaces/book.interface';

export const getAllSettingsService = async () => {
  try {
    const data = await callAPI('admin/settings/get-admin-settings');
    return data?.settings || [];
  } catch (error) {
    throw new Error('Failed to fetch settings');
  }
};

// Create/update a single admin setting. Sending a settingTitle makes the doc appear in the
// generic settings table too. Throws on error so callers can toast a message.
export const updateAdminSetting = async (settingKey: string, settingTitle: string, settingValue: string) => {
  const response = await callAPI('admin/settings/update-admin-settings/', { settingKey, settingTitle, settingValue });
  if (response?.error) throw new Error(response.error);
  return response;
};

export const stressTestBooksGeneration = async (books: number, pagesCount: number, generationMode: BookImageGenerationMode) => {
  try {
    const data = await callAPI('admin/settings/stress-test/generate-books', { books, pagesCount, generationMode });
    if (data?.status === 200) {
      toast.success(data?.message || 'Books generated successfully');
      return data?.message;
    }
    toast.error(data?.message || data?.error || 'Failed to generate books');
  } catch (error) {
    throw new Error('Failed to fetch settings');
  }
};
